import { render, staticRenderFns } from "./CentralAtendimento.vue?vue&type=template&id=1122d9d2&scoped=true"
import script from "./CentralAtendimento.vue?vue&type=script&lang=js"
export * from "./CentralAtendimento.vue?vue&type=script&lang=js"
import style0 from "./CentralAtendimento.vue?vue&type=style&index=0&id=1122d9d2&prod&scoped=true&lang=css"
import style1 from "./CentralAtendimento.vue?vue&type=style&index=1&id=1122d9d2&prod&scoped=true&lang=css"
import style2 from "./CentralAtendimento.vue?vue&type=style&index=2&id=1122d9d2&prod&lang=css"
import style3 from "./CentralAtendimento.vue?vue&type=style&index=3&id=1122d9d2&prod&lang=scss"
import style4 from "./CentralAtendimento.vue?vue&type=style&index=4&id=1122d9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122d9d2",
  null
  
)

export default component.exports